export default __webpack_public_path__ + "static/media/Step 7 Image.6b6aa38a.png";